import { Check, ChevronDown } from 'lucide-react';
import WDropdown from 'shared_components/components/WDropdownContent/WDropdown';
import WButton from 'shared_components/components/WForms/WButton/WButton';

export type DiscographyIdFilter = 'all' | 'verified' | 'uncertain' | 'rejected';

const FILTER_OPTIONS: { value: DiscographyIdFilter; label: string }[] = [
  { value: 'all', label: 'All IDs' },
  { value: 'verified', label: 'Verified IDs' },
  { value: 'uncertain', label: 'Uncertain IDs' },
  { value: 'rejected', label: 'Rejected' },
];

interface DiscographyIdFilterDropdownProps {
  value: DiscographyIdFilter;
  onChange: (value: DiscographyIdFilter) => void;
}

/** Same trigger + menu as the other toolbar dropdowns (e.g. Master Discography's "Show/Hide Data"). */
const DiscographyIdFilterDropdown = ({
  value,
  onChange,
}: DiscographyIdFilterDropdownProps) => {
  const current = FILTER_OPTIONS.find((option) => option.value === value);

  return (
    <WDropdown
      closeOnContentClick
      trigger={
        <WButton
          variant="secondary"
          label={
            <>
              {current?.label}
              <ChevronDown size={16} className="tw-ml-1.5" />
            </>
          }
        />
      }
      content={
        <div role="menu" className="tw-min-w-[160px] tw-text-sm">
          {FILTER_OPTIONS.map((option) => {
            const selected = option.value === value;
            return (
              <div
                key={option.value}
                role="menuitemradio"
                aria-checked={selected}
                tabIndex={0}
                className="tw-px-2 tw-py-2 tw-cursor-pointer hover:tw-bg-neutral-800 tw-flex tw-items-center tw-justify-between tw-gap-2"
                onClick={() => onChange(option.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onChange(option.value);
                  }
                }}
              >
                {option.label}
                {selected ? (
                  <Check
                    size={16}
                    aria-hidden="true"
                    className="tw-text-surfaceLime"
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      }
    />
  );
};

export default DiscographyIdFilterDropdown;
